import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { Spin } from 'antd';

interface LoaderWrapperProps {
  contents: boolean;
}

const LoaderWrapper = styled.div<LoaderWrapperProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 2rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.contents ? props.theme.colors.white : 'rgba(255,255,255,0.7)')};
  z-index: 1000;
`;

const Contents = styled.h3`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 1.8rem;
`;

interface MobileSectionLoaderProps {
  isLoading: boolean;
  contents?: string;
}

const MobileSectionLoader: React.FC<MobileSectionLoaderProps> = ({ isLoading, contents }) => {
  const [dots, setDots] = useState<string>(''); // dots 상태 관리

  if (!isLoading) return null; // isLoading이 false일 때 null을 반환하여 경고 해결

  return (
    <LoaderWrapper contents={contents === '' ? false : true}>
      <div>
        <Spin size="default" />
      </div>
      {isLoading && contents ? (
        <div>
          <Contents>
            {contents}
            {dots}
          </Contents>
        </div>
      ) : (
        <span style={{ marginLeft: 8 }}>로딩 중...</span>
      )}
    </LoaderWrapper>
  );
};

export default MobileSectionLoader;
